import { render, staticRenderFns } from "./dropdown-product.vue?vue&type=template&id=385b3cf8&scoped=true&"
import script from "./dropdown-product.vue?vue&type=script&lang=js&"
export * from "./dropdown-product.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-product.vue?vue&type=style&index=0&id=385b3cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b3cf8",
  null
  
)

export default component.exports